module.exports = __webpack_public_path__ + "assets/img/group-logo-acadb6f2.png";